import { type LeaderboardEntry, rankLabel } from '../models/types';
import { colors } from '../theme';

/** Fixed height of a row including its bottom gap. */
export const LEADERBOARD_ROW_EXTENT = 76;

/** One leaderboard entry: rank (medals for the top three), name and score on the board. */
export function LeaderboardRow({ entry, onClick, score }: { entry: LeaderboardEntry; onClick?: () => void; score?: string }) {
  return (
    <div className={`lb-row${entry.isMe ? ' me' : ''}`} data-testid={`lb-row-${entry.playerId}`}>
      <button type="button" className="bubble small" onClick={onClick}>
        <span className={`rank${entry.rank <= 3 ? ' medal' : ''}`}>{rankLabel(entry.rank)}</span>
        <span className="name">{entry.displayName}</span>
        {entry.isMe && <span className="chip" style={{ background: colors.lemon, padding: '4px 12px' }}>You</span>}
        <span style={{ opacity: 0.7 }}>{score ?? `${entry.score} found`}</span>
      </button>
    </div>
  );
}
